import { LegalDoc } from "@/components/site/LegalDoc";

export default function RefundPage() {
  return (
    <LegalDoc
      eyebrow="Refund Policy"
      title="Refunds & cancellations."
      updated="July 2026"
      intro="This policy explains how refunds work for wallet credits and shop subscription plans on Time2Cash."
      sections={[

{
  h: "Overview",

  p: [

"Time2Cash, a product of DIGISWING Innovation Private Limited, offers digital services including wallet credit purchases, business subscription plans, promotional services and other premium platform features. Since these services are delivered digitally, refund requests are evaluated carefully and only under the circumstances described in this policy.",

"This Refund & Cancellation Policy explains when refunds may be granted, how cancellation requests are handled and the situations in which refunds cannot be provided."

  ]
},

{
  h: "Digital Products & Services",

  p: [

"Purchases made on Time2Cash generally provide immediate access to digital products or services. These may include wallet credits, premium features, business plans, promotional services and similar digital offerings.",

"Because these products become available immediately after successful payment, they are generally considered consumed once delivered and therefore may not qualify for refunds."

  ]
},

{
  h: "Wallet Credits",

  p: [

"Wallet Credits are digital credits that enable access to eligible Time2Cash features. Once successfully credited to your account, they become available for immediate use.",

"Wallet Credits cannot normally be converted into cash, transferred to another account or refunded after successful delivery."

  ]
},

{
  h: "Business Subscription Plans",

  p: [

"Subscription plans are billed in advance for the selected duration. Subscription benefits remain available until the end of the active billing cycle.",

"You may cancel automatic renewals at any time. Cancellation prevents future charges but does not automatically entitle you to a refund for the remaining subscription period."

  ]
},

{
  h: "When You May Be Eligible for a Refund",

  p: [

"Refund requests may be considered after verification in situations including but not limited to the following:"

  ],

  list: [

"Duplicate payment for the same purchase.",

"Payment deducted but wallet credits were not received.",

"Subscription activated incorrectly due to a verified system issue.",

"Technical failure resulting in non-delivery of a purchased digital service.",

"Payment processed multiple times for a single order.",

"Incorrect billing caused by a verified platform error.",

"Any other exceptional circumstance approved by Time2Cash after investigation."

  ]

},

{
  h: "When Refunds Will Normally Not Be Provided",

  p: [

"Refunds are generally not available in the following situations:"

  ],

  list: [

"Wallet credits have already been used.",

"Change of mind after purchase.",

"User no longer wishes to use the platform.",

"Incorrect plan selected by the user.",

"Failure to read feature descriptions before purchase.",

"Services purchased but not used.",

"Account suspension due to Terms & Conditions violations.",

"Purchases made during promotional or special campaigns unless specifically stated.",

"Issues caused by incorrect information entered by the user.",

"Third-party bank processing delays after successful payment."

  ]

},

{
  h: "Failed Payments & Pending Transactions",

  p: [

"In certain cases, your bank may show a payment deduction while our systems do not receive confirmation from the payment gateway.",

"Such transactions are usually reversed automatically by your bank or payment provider within their standard processing timelines.",

"If the amount is neither credited to your Time2Cash account nor automatically reversed within the expected period, please contact our support team with your transaction details."

  ]

},

{
  h: "Cancellation Policy",

  p: [

"Users may discontinue paid services or cancel eligible subscriptions at any time through available account settings or by contacting support.",

"Cancellation prevents future renewals only. Any active subscription will continue until the current billing period expires."

  ]

},

{
  h: "Promotional Credits & Offers",

  p: [

"Promotional credits, referral rewards, campaign incentives, bonus credits and similar promotional benefits are provided solely for promotional purposes.",

"Such promotional credits have no cash value, cannot be transferred and are generally non-refundable."

  ]

},

{
  h: "Refund Review Process",

  p: [

"Every refund request is individually reviewed by our billing and support team.",

"We may request additional information including payment receipts, screenshots, transaction references or other documents before making a decision."

  ]
},

{
  h: "Processing Time",

  p: [

"Eligible refund requests are normally reviewed within 5 to 7 business days.",

"Once approved, refunds are initiated to the original payment method wherever technically possible."

  ]
},

{
  h: "Bank Processing Time",

  p: [

"Although Time2Cash initiates approved refunds promptly, the actual credit depends on your bank, card issuer, UPI provider or payment gateway.",

"Most financial institutions process refunds within 7 to 10 business days, although certain providers may require additional time."

  ]
},

{
  h: "Fraud Prevention",

  p: [

"Time2Cash reserves the right to refuse refund requests that appear fraudulent, abusive, repetitive or intended to misuse our refund process.",

"We may investigate suspicious refund requests and take appropriate action, including account suspension where necessary."

  ]
},

{
  h: "Policy Changes",

  p: [

"We may revise this Refund & Cancellation Policy from time to time to reflect changes in our services, payment systems or legal requirements.",

"The updated version will always be published on our website with the latest revision date."

  ]
},

{
  h: "Contact Us",

  p: [

"If you have questions regarding billing, payments, cancellations or refunds, please contact us:",

"Time2Cash",

"A Product of DIGISWING Innovation Private Limited",

"Website: www.time2cash.co",

"Email: hello@time2cash.co"

  ]
}

]}
    />
  );
}
